import script from "./AddExpenses.vue?vue&type=script&setup=true&lang=js"
export * from "./AddExpenses.vue?vue&type=script&setup=true&lang=js"

import "./AddExpenses.vue?vue&type=style&index=0&id=15b18b23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b18b23"]])

export default __exports__